if (!customElements.get('dsa-slideshow-hero')) {
  customElements.define(
    'dsa-slideshow-hero',
    class DsaSlideshowHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-slide-dot]'));
        this.index = 0;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.interval = (parseInt(this.dataset.interval || '6', 10) || 6) * 1000;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduce && this.slides.length > 1;
        this.paused = false;
        this.hovering = false;

        const prev = this.querySelector('[data-slide-prev]');
        const next = this.querySelector('[data-slide-next]');
        if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
        if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i, true)));
        this.pauseBtn = this.querySelector('[data-slide-pause]');
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', () => {
            this.paused = !this.paused;
            this.pauseBtn.textContent = this.paused ? 'Afspelen' : 'Pauzeren';
            this.pauseBtn.setAttribute('aria-pressed', String(this.paused));
            this.schedule();
          });
        }
        this.addEventListener('mouseenter', () => {
          this.hovering = true;
          this.stop();
        });
        this.addEventListener('mouseleave', () => {
          this.hovering = false;
          this.schedule();
        });
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.schedule());
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
          if (e.key === 'ArrowRight') this.go(this.index + 1, true);
        });

        let startX = null;
        this.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
        this.addEventListener(
          'touchend',
          (e) => {
            if (startX === null) return;
            const dx = e.changedTouches[0].clientX - startX;
            if (Math.abs(dx) > 50) this.go(this.index + (dx < 0 ? 1 : -1), true);
            startX = null;
          },
          { passive: true }
        );

        this.onBlockSelect = (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) {
            this.paused = true;
            this.go(i);
          }
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.go(0);
        this.schedule();
      }

      disconnectedCallback() {
        this.stop();
      }

      stop() {
        clearTimeout(this.timer);
      }

      schedule() {
        this.stop();
        if (!this.autoplay || this.paused || this.hovering) return;
        this.timer = setTimeout(() => this.go(this.index + 1), this.interval);
      }

      go(i, user) {
        const n = this.slides.length;
        if (!n) return;
        this.index = (i + n) % n;
        this.slides.forEach((s, k) => {
          const active = k === this.index;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', String(!active));
          s.querySelectorAll('a, button').forEach((el) => (el.tabIndex = active ? 0 : -1));
          const v = s.querySelector('video');
          if (v) {
            if (active && !this.reduce) v.play().catch(() => {});
            else v.pause();
          }
        });
        this.dots.forEach((d, k) => {
          if (k === this.index) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
        if (user && this.autoplay) this.schedule();
        else this.schedule();
      }
    }
  );
}
